import React, { useState, useContext, useEffect } from "react";
import { StyleContext } from "../providers/StyleContextProvider";
import { useMediaQuery } from "react-responsive";
import { Account } from "../components/RecruiterSettings/Account";
import { Integration } from "../components/RecruiterSettings/Integration";
import { Organization } from "../components/RecruiterSettings/Organization";
import { AuthContext } from '../providers/AuthContextProvider';
import { Button } from "../components/Shared/Buttons/Button";
import { Footer } from "../components/Shared/Footer";
import { useParams, useNavigate, createSearchParams, useLocation } from "react-router-dom";
import { RecruiterMenu } from "../components/Shared/RecruiterMenu";
import { LoggedRecruiter } from '../models/LoggedRecruiter';
import { ProfileEntrance } from "../components/Home/ProfileEntrance";
import { ReactComponent as Search } from '../assets/svg/search.svg';

export const RecruiterSettingsPage: React.FC = () => {
    let params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const authContext = useContext(AuthContext);
    const styleContext = useContext(StyleContext);
    const recruiter: LoggedRecruiter = authContext.getLoggedRecruiter();
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("recruiterSettings"));
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const tab = params.tabs;
    const [searchTerm, setSearchTerm] = useState<string>("");

    useEffect(() => {
        setStyles(styleContext.getComponentStyle("recruiterSettings"));
    }, [isMobile]);

    useEffect(() => {                    
        if(recruiter === null) {  
            const params = { callbackUrl: location.pathname + location.search, message: "Please login or register to view the Setting page." };
            navigate({
                pathname: '/recruiter/account/login',
                search: `?${createSearchParams(params)}`
            });
        } 
    }, []);
    
    const handleButtonClick = (tab : string) => {
        navigate(`/recruiter/settings/${tab}`);
    }

    return(
        <>
            <div style={styles.mainWrapper}>
                <div style={styles.leftWrapper}> 
                    <RecruiterMenu/>
                </div>
                <div style={styles.rightWrapper}> 
                    <div style={styles.headerWrapper}>
                        <div style={styles.searchWrapper}>
                            <div style={styles.searchBar}>
                                <input style={styles.searchBar.input} placeholder={"Search"} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
                                <Search style={styles.searchBar.icon}/>
                            </div>
                            <div style={styles.profileWrapper}><ProfileEntrance recruiter={recruiter} /></div>
                        </div>
                    </div>
                    <div style={styles.topic}> Settings </div>
                    <div style={styles.tabcontent}> 
                        <Button style={{...styles.tab, ...(tab === "account" && styles.tab.active)}} onClick={()=> handleButtonClick("account")}>{"Account"}</Button>
                        <Button style={{...styles.tab, ...(tab === "organization" && styles.tab.active)}} onClick={()=> handleButtonClick("organization")}>{"Organization"}</Button>
                        <Button style={{...styles.tab, ...(tab === "integration" && styles.tab.active)}} onClick={()=> handleButtonClick("integration")}>{"Integration"}</Button>
                    </div>
                    <div style={styles.content}>
                        {tab === 'account' && <Account recruiter={recruiter} styles={styles.account}/>}
                        {tab === 'organization' && <Organization recruiter={recruiter} styles={styles.organization}/>}
                        {tab === 'integration' && <Integration recruiter={recruiter} styles={styles.integration}/>}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}